/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { StatementResponse } from '../models/statement-response';

/**
 * Registration statement endpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class RegistrationStatementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getProductRegistrationStatement
   */
  static readonly GetProductRegistrationStatementPath = '/statements/actual';

  /**
   * Gets registration statement.
   *
   * Finds and returns the current registration statement.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductRegistrationStatement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductRegistrationStatement$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<StatementResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      RegistrationStatementService.GetProductRegistrationStatementPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<StatementResponse>;
        })
      );
  }

  /**
   * Gets registration statement.
   *
   * Finds and returns the current registration statement.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductRegistrationStatement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductRegistrationStatement(
    params?: {},
    context?: HttpContext
  ): Observable<StatementResponse> {
    return this.getProductRegistrationStatement$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<StatementResponse>) =>
          r.body as StatementResponse
      )
    );
  }
}
